import React, { Component } from 'react';
import 'HELPDESK/Components/ModuleCertification/CertificateList/CertificateList.css';
import config from 'config';
import HelpdeskApiCall from 'HelpdeskApiCall';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-js-pagination';
import DeleteTextModal from 'HELPDESK/CommonResources/DeleteTextModal/DeleteTextModal';
import ReactToPrint from 'react-to-print';

class CertificateList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //VARIABLES TO SHOW CERTIFICATE LIST
            CertificateListFetching:false,
            pageIndex:1,
            limit:10,
            certificateList:{},
            sequenceIdArray:[],
            totalCount:0,
            currentLoadedEntries:0,
            isDeleted:this.props.isDeleted,
            deletedCertificateId:this.props.deletedCertificateId

            
        };
    }

    componentDidMount() {
       // API CALL METHOD TO GET CERTIFICATE DETAILS
       this.apiCallToGetCertificateList();
    }

    componentDidUpdate() {
        if(this.state.isDeleted && this.state.deletedCertificateId.length>0 && this.state.sequenceIdArray.length>0)
        {
            let deletedCertificateId = this.state.deletedCertificateId;
            let sequenceIdArray = this.state.sequenceIdArray;
            sequenceIdArray = sequenceIdArray.filter(id => id!= deletedCertificateId);
            let certificateList = this.state.certificateList;
            delete certificateList[this.state.deletedCertificateId];
            let totalCount = this.state.totalCount;
            totalCount--;
            let currentLoadedEntries = this.state.currentLoadedEntries;
            currentLoadedEntries--;
            
            this.setState({
                sequenceIdArray,
                certificateList,
                currentLoadedEntries,
                totalCount
            })
        }
    }

    // API CALL METHOD TO GET CERTIFICATE DETAILS
    apiCallToGetCertificateList = async () => {
        this.setState({
            CertificateListFetching: true
        });

        let requestData = {
            "iid": config.institute_id,
            "facultyId":config.faculty_id,
            "pageIndex":this.state.pageIndex,
            "limit" :this.state.limit
            // "search": this.state.searchTerm
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskModuleCertificationList',
            requestData,
            '/api/helpDesk/employee/moduleCertification.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetCertificateList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let sequenceIdArray = apiResult.sequenceIdArray;
                let currentLoadedEntries = this.state.currentLoadedEntries;
                currentLoadedEntries = currentLoadedEntries + Object.keys(apiResult.data);
                this.setState({
                    CertificateListFetching: false,
                    certificateList: apiResult.data,
                    sequenceIdArray,
                    totalCount: apiResult.total,
                    currentLoadedEntries
                    
                });
            } else {
                this.setState({
                    CertificateListFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting certification details. Please try again later.'
                });
            }
        }
    }
    // METHOD TO GET LIMIT PER PAGE
    getPerPageLimit = (e) => {
        this.setState({
            limit: e.target.value,
            offset: 0,
            pageIndex: 1,
            currentLoadedEntries: 0,
            certificateList: {},
            sequenceIdArray: []
        }, () => {
            this.apiCallToGetCertificateList();
        });
    }

    // METHOD TO GET CERTIFICATE LIST ON SCROLL
    getAssetListOnScroll = (e) => {
        var element = e.target;

        if (parseInt(element.scrollHeight - element.scrollTop) == parseInt(element.clientHeight)) {
            if (this.state.assetCount > this.state.currentLoadedEntries) {
                this.setState({
                    pageIndex: this.state.pageIndex + 1,
                }, () => {
                    this.apiCallToGetCertificateList();
                });
            }
        }
    }
    // METHOD TO GET MORE Certificate
    getMoreCertificate = () => {
        if (this.state.totalCount > this.state.currentLoadedEntries) {
            this.setState({
                pageIndex: this.state.pageIndex + 1,
            }, () => {
                this.apiCallToGetCertificateList();
            });
        }
    }

    
    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }
    substringString =(language,stringLength) =>{
        return language.length > stringLength ? language.substring(0,stringLength)+"...":language;
    }


    render() {
        return (
            <>
                {
                    this.state.CertificateListFetching ? 
                        <ButtonLoader/>
                    :
                        <div className=" certificateList">
                            {
                                Object.values(this.state.certificateList).length > 0 ?
                                    Object.values(this.state.certificateList).map((certificate,certificateIndex) => {
                                        return(
                                            <div className="CertificateContainer card" title="Click to view certification details" key={certificate.uniqueid} onClick={()=>this.props.showCertificateDetailsComponent(certificate)}>                                    
                                                <div className='stack-top left' style={{ background: certificate.certification_status == "Completed" ? '#219653' : '#FF7800' }}>
                                                    {certificate.certification_status}
                                                </div>
                                                <div className="ModuleIcon">
                                                    <FontAwesomeIcon  icon={['fas', certificate.moduleIcon]} />
                                                </div>
                                                <div className="ModuleName" >
                                                    {certificate.moduleName}
                                                </div>
                                                <div className="languages" >
                                                    {
                                                        this.substringString(certificate.supportingLanguageArray.join(", "),50)
                                                    }                                                    
                                                </div>
                                                <div className="moduleTrainings">
                                                    <div className="trainingIcon">
                                                        <FontAwesomeIcon icon={['fas', 'video']} color="#2264D1" />
                                                    </div>
                                                    <div className="trainingData">
                                                        <p style={{ color: '#3A3A44', fontFamily: 'Raleway', fontSize: 18, fontWeight: 'bold' }}>0</p>
                                                        <p style={{ fontSize: 14, color: '#4A4B57', fontWeight: 'bold' }}>Training(s)</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                :
                                    <p>Certificate is not created yet.</p>
                            }
                        </div>                    
                }                
                {
                    this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal} 
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal} 
                        />
                }
                <br/>
            </>
        );
    }
}

export default CertificateList;